// extracted by mini-css-extract-plugin
export default {"selectionModal":"SelectedResourcesModal_selectionModal__LXinV"};